import React, { useEffect, useContext, useState } from 'react'
import styled from 'styled-components'
import { AccountUpdateTemplate } from '../../templates/AccountUpdateTemplate'
import PropTypes from 'prop-types'
import { accountRevalidate } from '../../../api/revalidateApi'
import { RevalidationContext } from '../../../util/providers/RevalidationProvider'
import httpStatus from 'http-status'

const Content = styled.div`
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
  max-width: 500px;
`

const AccountUpdatePage = ({
  onClickRevalidatePhone,
  onClickRevalidateEmail,
  afterRevalidation,
}) => {
  const { token, setDataValidations, lurker } = useContext(RevalidationContext)
  const [error, setError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const getAccountRevalidate = async () => {
    setIsLoading(true)

    await accountRevalidate(token)
      .then(({ data }) => {
        setDataValidations(data?.validationFields)

        const { loginResponse } = data

        if (loginResponse?.token) {
          lurker.viewMessageEvt('login_success', {
            accountId: loginResponse.accountsId,
            flow: 'account_revalidation',
            context: 'revalidation',
          })
        }

        setError(false)
      })
      .catch(({ response }) => {
        const UNAUTHORIZED =
          httpStatus.UNAUTHORIZED === response?.status &&
          response?.data?.message === 'ACCOUNT_NOT_VALIDATED'

        if (!UNAUTHORIZED) {
          setError(true)
          return
        }

        if (response?.data?.validationFields) {
          setDataValidations(response.data.validationFields)
        }
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    lurker.pageLoadEvt('revalidation')
    getAccountRevalidate()
  }, [])

  return (
    <Content>
      <AccountUpdateTemplate
        onClickRevalidatePhone={onClickRevalidatePhone}
        onClickRevalidateEmail={onClickRevalidateEmail}
        onSuccessDocument={getAccountRevalidate}
        error={error}
        afterRevalidation={afterRevalidation}
        isLoading={isLoading}
      />
    </Content>
  )
}

AccountUpdatePage.propTypes = {
  onClickRevalidatePhone: PropTypes.func.isRequired,
  onClickRevalidateEmail: PropTypes.func.isRequired,
  afterRevalidation: PropTypes.func,
}

export default AccountUpdatePage
